import "lazysizes";
import "lazysizes/plugins/native-loading/ls.native-loading";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import "./components/header";
import "./components/bandeaux";
import "./components/liste-reves";
import "./components/apropos";
import "./components/profil";
import "./components/filtres";
import "./components/page-transition";
// CREATION DU DESSIN
import "./components/dessin.js";
// SELECTIONNER LES REVES
// import "./components/selection-reves-helpers.js";
// import "./components/selection-reves.js";
// CREATION DU TABLEAU POUR TELECHARGER LES REVES
//import "./components/table-to-pdf-helpers.js";
//import "./components/table-to-pdf.js";
import "./components/download-reves.js";

const isFirefox = navigator.userAgent.toLowerCase().match(/firefox|fxios/i);

if (isFirefox) {
  document.body.classList.add("is-firefox");
}

const $formCreation = document.querySelector("#form--creation-reve");

if ($formCreation) {
  const sommeils = document.querySelectorAll(
    ".creation-modalite .acf-checkbox-list li"
  );
  const humeurs = document.querySelectorAll(
    ".creation-humeur .acf-checkbox-list li"
  );
  const activites = document.querySelectorAll(
    ".creation-activite .acf-checkbox-list li"
  );
  const lieux = document.querySelectorAll(
    ".creation-lieu .acf-checkbox-list li"
  );
  const modalites = [sommeils, humeurs, activites, lieux];

  // const checkboxList = $formCreation.querySelectorAll(".acf-checkbox-list li");
  modalites.forEach((modalite) => {
    modalite.forEach((item) => {
      const label = item.querySelector("label");
      const input = label.querySelector("input");
      input.addEventListener("change", (e) => {
        if (input.checked) {
          label.classList.add("is-checked");
        } else {
          label.classList.remove("is-checked");
        }
      });
    });
  });
}

/**
 * MODIFICATION LABEL Titre & Modalités de sommeil
 */

const creationTitreLabel = document.querySelector(
  'label[for="acf-_post_title"'
);

creationTitreLabel &&
  (creationTitreLabel.innerHTML = 'Titre <span class="acf-required">*</span>');

const creationModalitesLabel = document.querySelector(
  'label[for="acf-field_62ab4b7c81114"'
);

creationModalitesLabel &&
  (creationModalitesLabel.innerHTML = "Facteurs biochimiques ou naturels");

/**
 * AJOUT DE LABEL Pour modalites de sommeil
 */
const creationLucidite = document.querySelector(".creation-lucidite");
const contenuModalitesTitle = `
<div class="acf-field acf-field-contenu creation-toutes-modalites">
    <div class="acf-label">
        <label>Modalites du sommeil</label>
    </div>
</div>
`;
creationLucidite &&
  creationLucidite.insertAdjacentHTML("afterend", contenuModalitesTitle);

/******************************************************************
 * AJOUT DE LABEL POUR CONTENU & SOUVENIR DU REVE
 *****************************************************************/
const datePicker = document.querySelector("#date-du-reve");
const lieu = document.querySelector(".acf-field-62ab4bee81117");
const contenuTitle = `
     <div class="acf-field acf-field-contenu creation-contenu">
         <div class="acf-label">
             <label>Contenu</label>
         </div>
         <div class="contenu--buttons">
             <div class="button-round-corner button-medium creation-contenu-button creation-contenu-button_texte">Texte</div>
             <div class="button-round-corner button-medium creation-contenu-button creation-contenu-button_dessin">Dessin</div>
         </div>
     </div>
 `;
const SouvenirReveTitle = `
     <div class="acf-field acf-field-souvenir-reve">
         <div class="acf-label">
             <label>Souvenir du rêve</label>
     </div>
 `;

if (datePicker && lieu) {
  // Creation de la zone Contenu
  datePicker.insertAdjacentHTML("afterend", contenuTitle);
  // Creation de la zone Souvenir du reve
  lieu.insertAdjacentHTML("afterend", SouvenirReveTitle);
}

/******************************************************************
 * SELECTION DU TYPE DE CONTENU
 *****************************************************************/

const contenuTexte = document.querySelector(".acf-field-62ab4ab08110f");
const contenuTexteArea = document.querySelector("#acf-field_62ab4ab08110f");
const contenuDessin = document.querySelector(".acf-field-6101620bb8f45");
const buttonText = document.querySelector(".creation-contenu-button_texte");
const buttonDessin = document.querySelector(".creation-contenu-button_dessin");
const containerDessin = document.querySelector(".dessin--wrapper");
const containerCreationReve = document.querySelector(".content--creation-reve");

window.addEventListener("DOMContentLoaded", (e) => {
  if (contenuTexteArea && buttonText && buttonDessin) {
    contenuTexteArea.addEventListener("focus", () => {
      contenuTexte.classList.add("is-active");
      buttonText.classList.add("is-active");
    });
    buttonText.addEventListener("click", (e) => {
      buttonText.classList.toggle("is-active");
      contenuTexte.classList.toggle("is-active");
    });
    buttonDessin.addEventListener("click", (e) => {
      buttonDessin.classList.toggle("is-active");
      containerDessin.classList.add("-is-active");
    });
  }
});
